<template>
    <scroll-content-styled class="scroller" :isArticle="isArticle" @scroll="scrollHandler">
        <slot />
        <transition name="fade">
            <div class="top-button" v-if="visible">
                <div class="top-button-arrow" @click="scrollTo">
                    <awesome-icon class="first" name="angle-up" noMargin />
                    <awesome-icon class="second" name="angle-up" noMargin />
                    <awesome-icon class="third" name="angle-up" noMargin />
                </div>
            </div>
        </transition>
    </scroll-content-styled>
</template>
<script>
import styled, { css } from "vue-styled-components";
import { scrollCalculator } from "../utils/lib";

const props = {
    isArticle: Boolean,
};

const ScrollContentStyled = styled("div", props)`
    display: block;
    position: relative;
    padding-top: 36px;
    padding-bottom: 70px;

    .top-button {
        width: ${(props) => props.theme.size.container_w};
        display: ${(props) => (props.isArticle ? "none" : "block")};
        position: fixed;
        left: 50%;
        bottom: 0px;
        transform: translateX(-50%);
        z-index: 8;

        &-arrow {
            cursor: pointer;
            width: 4.8rem;
            height: 4.8rem;
            position: absolute;
            border-radius: 4.8rem;
            background-color: ${(props) => props.theme.color.primary};
            color: #ffffff;
            font-size: 3rem;
            bottom: 2.4rem;
            right: -6.2rem;
            box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);
            transition: all 0.35s;

            svg {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                transition: all 0.35s;
            }
        }

        &:hover .top-button-arrow {
            height: 9.6rem;

            .first svg {
                top: 35%;
            }

            .second svg {
                opacity: 0.8;
            }

            .third svg {
                top: 65%;
                opacity: 0.6;
            }
        }
    }
`;

export default {
    name: "ScrollContent",
    data: () => ({
        visible: false,
        scrollTop: 0,
        isMemoize: true,
    }),
    props: {
        ...props,
        distance: Number,
        afterScroll: Number,
    },
    methods: {
        scrollHandler(ev) {
            const { offsetHeight, scrollHeight, scrollTop } = ev.target;
            scrollCalculator(offsetHeight, scrollHeight, scrollTop, this.distance, () => this.$emit("over-scroll"));

            if (this.isMemoize) {
                this.scrollTop = scrollTop;
            }

            this.$emit("scroll", ev.target);

            if (scrollTop > 200 && !this.visible) {
                this.visible = true;
            }

            if (scrollTop < 200 && this.visible) {
                this.visible = false;
            }
        },

        topHandler() {
            this.scrollTo(0);
        },

        scrollTo() {
            if (this.scrollTop > 0) {
                this.isMemoize = false;
            }

            this.$nextTick(() => {
                const el = document.querySelector("#container");
                // 기록 다시하기
                if (this.scrollTop < 0) {
                    this.isMemoize = true;
                    this.scrollTop = 0;
                }

                if (this.scrollTop > 0) {
                    // 0 으로 만들기
                    this.scrollTop = this.scrollTop - 150;
                    el.scrollTop = this.scrollTop;
                    // animation 적용
                    window.requestAnimationFrame(this.scrollTo);
                }
            });
        },
    },

    mounted() {
        const container = document.querySelector("#container");
        container.addEventListener("scroll", this.scrollHandler);

        if (container.scrollHeight !== 0) {
            container.scrollTop = this.afterScroll;
        }
    },

    beforeDestroy() {
        const container = document.querySelector("#container");

        if (container) {
            this.$emit("before-destroyed", this.scrollTop);
            container.removeEventListener("scroll", this.scrollHandler);
        }
    },
    components: {
        ScrollContentStyled,
    },
};
</script>
